import { MACRO_MEDIA_BASE } from './data/media';

export const ICONS = {
  // Logo de wallet Modo
  'modo-blue': { src: `${MACRO_MEDIA_BASE}/wallets/modo-blue.png`, aspectRatio: 423 / 97, defaultHeight: 22 },
  'modo-white': { src: `${MACRO_MEDIA_BASE}/wallets/modo-white.png`, aspectRatio: 423 / 97, defaultHeight: 22 },

  // Logo de Macro (sombrerito)
  icono: { src: `${MACRO_MEDIA_BASE}/logos/icono.png`, aspectRatio: 3184 / 2042, defaultHeight: 34 },
  'icono-white': { src: `${MACRO_MEDIA_BASE}/logos/icono-white.png`, aspectRatio: 3184 / 2042, defaultHeight: 34 }
} as const;

export type IconName = keyof typeof ICONS;
